import React from 'react'

import type { IconProps } from '../iconProps'
import { s } from './icon.style'

export const ChevronRightFillIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ size = 16, name = 'icon', color, style, ...props }: IconProps, ref) => {
    return (
      <svg
        viewBox="0 0 24 24"
        css={s}
        style={{ width: size, color, ...style }}
        data-svg-name={name}
        {...props}
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="2" y="2" width="20" height="20" rx="10" fill="#333333" />
        <path
          d="M9.15845 15.6167L12.9751 11.7917L9.15845 7.96666L10.3334 6.79166L15.3334 11.7917L10.3334 16.7917L9.15845 15.6167Z"
          fill="white"
        />
      </svg>
    )
  },
)
